import React from "react";
import { Paper, Box } from "@mui/material";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const RateGauge = ({ engagementRate, executionRate }) => {
  const engagement = Math.min(Math.max(engagementRate, 0), 100);
  const realization = Math.min(Math.max(executionRate, 0), 100);

  const COLORS1 = ["#1976d2", "#eeeeee"]; // engagement: bleu
  const COLORS2 = ["#388e3c", "#eeeeee"]; // realization: vert

  const dataEngagement = [
    { name: "Engagé", value: engagement },
    { name: "Restant", value: 100 - engagement },
  ];

  const dataRealization = [
    { name: "Réalisé", value: realization },
    { name: "Restant", value: 100 - realization },
  ];

  return (
    <Paper elevation={3} sx={{ p: 3, borderRadius: 2, height: "100%" ,}}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {/* Première jauge - Engagement */}
        <Box
          sx={{
            position: "relative",
            width: 250,
            height: 240,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                startAngle={180}
                endAngle={0}
                data={dataEngagement}
                innerRadius={60}
                outerRadius={80}
                paddingAngle={5}
                dataKey="value"
                stroke="none"
              >
                {dataEngagement.map((entry, index) => (
                  <Cell key={`cell-engage-${index}`} fill={COLORS1[index]} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>

          <Box
            sx={{
              position: "absolute",
              top: "45%",
              left: "50%",
              transform: "translate(-50%, -60%)",
              fontSize: 24,
              fontWeight: "bold",
              color: "#1976d2",
            }}
          >
            {engagement.toFixed(2)}%
          </Box>
          <Box
            sx={{
              position: "absolute",
              top: "70%",
              left: "50%",
              transform: "translateX(-50%)",
              fontSize: "1rem",
              color: "black",
              textAlign: "center",
              width: "90%",
            }}
          >
            Actuellement, {engagement.toFixed(2)}% du budget global estimé est engagé.
          </Box>
        </Box>

        {/* Deuxième jauge - Réalisation */}
        <Box
          sx={{
            position: "relative",
            width: 250,
            height: 240,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                startAngle={180}
                endAngle={0}
                data={dataRealization}
                innerRadius={60}
                outerRadius={80}
                paddingAngle={5}
                dataKey="value"
                stroke="none"
              >
                {dataRealization.map((entry, index) => (
                  <Cell key={`cell-real-${index}`} fill={COLORS2[index]} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>

          <Box
            sx={{
              position: "absolute",
              top: "45%",
              left: "50%",
              transform: "translate(-50%, -60%)",
              fontSize: 24,
              fontWeight: "bold",
              color: "#388e3c",
            }}
          >
            {realization.toFixed(2)}%
          </Box>
          <Box
            sx={{
              position: "absolute",
              top: "70%",
              left: "50%",
              transform: "translateX(-50%)",
              fontSize: "1rem",
              color: "black",
              textAlign: "center",
              width: "90%",
            }}
          >
            Actuellement, {realization.toFixed(2)}% du budget engagé est réalisé.
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default RateGauge;
